export const numberWithCommas = (num?: number) =>
  !num || isNaN(num) ? 0 : num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const getValueWithCurrencySign = (num?: number, currency = '') => {
  const result = num ? numberWithCommas(num) : 0;
  return result != 0 && result.toString().includes('-')
    ? `(${currency}${result})`.replace('-', '')
    : `${currency}${result}`;
};

export const numberWithCommasFixedNumbers = (num?: number, tofixed = 2) =>
  !num || isNaN(num) ? 0 : num?.toFixed(tofixed).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
